exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-antd-select-container {\n  display: inline-block;\n}\n.is-antd-select-container .is-antd-select {\n  width: 160px;\n  text-align: left;\n}\n.ant-select-tree-list-scrollbar {\n  width: 4px !important;\n}\n.ant-select {\n  width: 100%;\n  max-width: 200px;\n}\n", ""]);

// exports
